import api from './api';
import types from './mutation-types';
import state from './state';

export default {
	defaultAssign_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, {
			key,
			value
		});
	},

	setModalValue_({ commit }, { key, value }) {
		commit(types.SET_MODAL_VALUE, { key, value });
	},

	setDetailValue_({ commit }, { key, value }) {
		commit(types.SET_DETAIL_VALUE, { key, value });
	},

	getVersion_({ commit }) {
		return api
			.getVersion()
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_OPTION_CODE_LIST, {
						key: 'vers',
						list: data.body
					});
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	getCategory_({ commit }) {
		return api
			.getCategory()
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_OPTION_CODE_LIST, {
						key: 'categorys',
						list: data.body
					});
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	getDtlCategory_({ commit }) {
		return api
			.getDtlCategory()
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_OPTION_CODE_LIST, {
						key: 'dtlCategorys',
						list: data.body
					});
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	getGuideBoardList_({ commit }, params = { ver, category, dtlCategory, title, currentPage, pageUnit }) {
		return api
			.getGuideBoardList(params)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_SEARCH_PARAM, params);
					const { currentPage, pageUnit, totalSize } = data.body.pagingInfo;
					commit(types.DEFAULT_ASSIGN, {
						key: 'groups',
						value: { currentPage, pageUnit, totalSize, data: data.body.resultList }
					});
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	addGuide_({ commit }, { formData }) {
		return api
			.addGuide({ formData })
			.then(data => {
				if (data.header.code === 0) {
					return data.header;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	saveGuide_({ commit }, { formData }) {
		return api
			.saveGuide({ formData })
			.then(data => {
				if (data.header.code === 0) {
					return data.header;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	delGuide_({ rootState }, { params }) {
		return api
			.delGuide({ params })
			.then(data => {
				if (data.header.code === 0) {
					return data.header;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},
	imgDownload_({ state, commit }, params = { no, seq }) {
		return api
			.fileDownload({ params })
			.then(response => {
				const filename = decodeURIComponent(response.headers.filename);
				const filetype = decodeURIComponent(filename.substring(filename.lastIndexOf('.') + 1));
				let url = '';
				if ('|JPG|PNG|GIF|'.indexOf(filetype.toUpperCase()) > -1)
					url = window.URL.createObjectURL(new Blob([response.data], { type: 'image/png' }));

				return { name: filename, url };
			})
			.catch(error => {
				throw error;
			});
	},

	fileDownload_({ state, commit }, params = { no, seq }) {
		return api
			.fileDownload({ params })
			.then(response => {
				//console.log('response', response);
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				const filename = decodeURIComponent(response.headers.filename);
				link.setAttribute('download', filename);
				//console.log('filename', filename);
				document.body.appendChild(link);
				link.click();
			})
			.catch(error => {
				throw error;
			});
	},

	addTables_({ rootState }, { params }) {
		return api
			.addTables({ plantCd: rootState.commonStore.user.plantCd, params })
			.then(data => {
				if (data.header.code === 0) {
					return data.header;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	saveTables_({ rootState }, { params }) {
		return api
			.saveTables({ plantCd: rootState.commonStore.user.plantCd, params })
			.then(data => {
				if (data.header.code === 0) {
					return data.header;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	delTables_({ rootState }, { params }) {
		return api
			.delTables({ plantCd: rootState.commonStore.user.plantCd, params })
			.then(data => {
				if (data.header.code === 0) {
					return data.header;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	closeModal_({ commit }) {
		commit(types.DEFAULT_ASSIGN, {
			key: 'GuideBoardModalValue',
			value: {
				flg: 'I',
				boardNo: '',
				ver: '',
				category: '',
				dtlCategory: '',
				title: '',
				regId: '',
				fileList: [],
				conts: `1. 변경된 원인/사유 : 

2. FW버전변경/소스변경/데이터추가 : 

3. 상세 내용 : 

4. 개선되는 효과 : `
			}
		});

		commit(types.DEFAULT_ASSIGN, {
			key: 'GuideBoardModal',
			value: false
		});
	},

	closeDetail_({ commit }) {
		commit(types.DEFAULT_ASSIGN, {
			key: 'GuideBoardDetailValue',
			value: {
				boardNo: '',
				ver: '',
				category: '',
				dtlCategory: '',
				title: '',
				conts: '',
				regId: '',
				fileList: [],
				delList: '|',
				imgList: []
			}
		});

		commit(types.DEFAULT_ASSIGN, {
			key: 'GuideBoardDetail',
			value: false
		});
	}
};
